import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor() {}

  downloadFile(blob: Blob, fileName: string = 'Download.xlsx'): void {
    // Create a URL for the Blob (binary data)
    const url = window.URL.createObjectURL(blob);

    // Create an <a> element to trigger the download
    const a = document.createElement('a');
    a.href = url; // Set the URL of the Blob as the href of the <a> tag
    a.download = fileName;

    // Trigger the click event on the <a> element to start the download
    a.click();

    // Clean up the created URL to free up memory once the download is triggered
    window.URL.revokeObjectURL(url);
  }
}
